import Application from "../../Application";
import Report4Presenter, {
  IReport4Presenter
} from "../../presenter/report/Report4Presenter";
import { IReportService } from "../../service/report/ReportService";
import { INotificationService } from "../../service/notification/NotificationService";

export default class ShowReport4PageInteractor {
  private application: Application;
  private output?: IReport4Presenter;
  private reportService: IReportService;
  private notificationService: INotificationService;

  constructor(application, reportService, notificationService) {
    this.application = application;
    this.reportService = reportService;
    this.notificationService = notificationService;
  }

  async getReportingPeriodList() {
    try {
      return this.reportService.getReportingPeriodList();
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = Report4Presenter({
      application: this.application,
      initialState: {
        report4ReportingPeriodList: [],
        report4SelectedRiskCriteriaIds: [],
        report4RiskCriteria: [],
        report4CurrentReportingPeriod: undefined,
        report4: undefined
      }
    });

    this.getReportingPeriodList().then(
      (reportingPeriodList) =>
        this.output &&
        this.output.loadReportingPeriodList(reportingPeriodList || [])
    );

    return this.output;
  }
}
